module.exports = __webpack_public_path__ + "static/media/email-map-bg.75b75665.png";